import { NgFilter } from "@app/di/decorators";
import { Token } from "@app/di/token";

/**
 * used in ng-repeat to have something like a for loop instead of looping over a collection
 */
@NgFilter({
    token: Token.RangeFilter,
    dependencies: [
    ]
})
export class RangeFilter {
    constructor() {
        return ((input: any[], total: number) => {

            total = parseInt(total as any, 10);
            for (let i = 0; i < total; i++) {
                input.push(i);
            }

            return input;
        }) as any;
    }
}
